import * as AssetDownload from 'bundles/ent-website/contentful/modules/MarketoFormModules/AssetDownload';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import * as CompanySizeLicenseCount from 'bundles/ent-website/contentful/modules/MarketoFormModules/CompanySizeLicenseCount';
import * as HiddenFields from 'bundles/ent-website/contentful/modules/MarketoFormModules/HiddenFields';

const onLoad = [HiddenFields.populateMarketoHiddenFields];
const beforeSubmit = [CompanySizeLicenseCount.concatSizeLicense];
const beforeSuccess = [AssetDownload.downloadAsset];

export { onLoad, beforeSubmit, beforeSuccess };
